// src/features/auth/authAxios.js

import axiosTuri from "../../axiosTuri";

export const getCsrfCookie = async () => {
  await axiosTuri.get("/sanctum/csrf-cookie");
};

// Kept all original function names.

export const signIn = async (data) => {
  const res = await axiosTuri.post(`auth/login`, data);
  return res.data;
};

// CORRECTED: No token parameter needed. The interceptor handles it.
export const userLoaded = async () => {
  const res = await axiosTuri.get(`auth/user-loaded`);
  return res.data;
};

// CORRECTED: No token parameter needed. The interceptor handles it.
export const signOut = async () => {
  const res = await axiosTuri.post(`auth/logout`, {});
  return res.data;
};

export const forgetPassword = async (data) => {
  const res = await axiosTuri.post(`auth/forget-password`, data);
  return res.data;
};

export const resetPassword = async (data) => {
  const res = await axiosTuri.post(`auth/reset-password`, data);
  return res.data;
};

// CORRECTED: No token parameter needed. The interceptor adds the Authorization header.
// We only need a config for the Content-Type.
export const update = async (data) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  const res = await axiosTuri.post(`auth/update`, data, config);
  return res.data;
};
